/* src/app/components/area/area.component.css */
google-map {
  height: 300px;
  width: 100%;
}
:host ::ng-deep .map-container {
  max-width: 100% !important;
  max-height: 100% !important;
}
#simulation {
  margin-top: 10px;
}
@media (min-width: 768px) {
  google-map {
    height: 450px;
  }
}
/*# sourceMappingURL=area.component.css.map */
